// extracted by mini-css-extract-plugin
export default {"header":"SingleTask_header__1hpN3","closeButton":"SingleTask_closeButton__SHocQ"};